module.exports = __webpack_public_path__ + "img/LOGO-Isoletta.040ca038.png";